// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"703":"db5c299e","883":"977adcce"}[chunkId] + ".chunk.js";
};